export const workOrderListRoute = {
    path: "/work-order",
    name: "work-order-list",
    component: () => import("../ui/work-order/work-order-list.vue")
};